export default "__VITE_ASSET__DxYdxMHx__"